<template>
    <div :class="isLoading ? 'is-loading' : ''">

        <!-- filters -->
        <aside class="d-print-none">
            <!-- Type -->
            <ul class="nav nav-pills flex-nowrap flex-md-wrap gap-3 overflow-auto overflow-md-visible pt-2 pb-3 mb-4 px-2 px-md-0">
                <li class="nav-item">
                    <button :class="['text-uppercase nav-link shadow fs-7 px-4 py-2 text-nowrap', filters.type === 'active' ? 'active' : '']" @click="selectType('active')">{{ translate('Active projects') }}</button>
                </li>
                <li class="nav-item">
                    <button :class="['text-uppercase nav-link shadow fs-7 px-4 py-2 text-nowrap', filters.type === 'done' ? 'active' : '']" @click="selectType('done')">{{ translate('Done projects') }}</button>
                </li>
            </ul>
        </aside>

        <!-- order -->
        <aside class="mt-3 mb-5 d-print-none">
            <vSelect  
                style="width: 260px;"
                class="ReverseIcon PrimaryArrowBg"
                :options="[{ label: translate('Sort alphabet'), value: 'alphabet' }, { label: translate('Sort date end'), value: 'date' }]" 
                v-model="filters.order"  
                :clearable="false"
                :searchable="false"
                :reduce="option => option.value" 
                label="label"
            >
                <template #open-indicator="{ attributes }">
                    <svg class="icon-filter text-white" v-bind="attributes">
                        <use xlink:href="#icon-filter"></use>
                    </svg>
                </template>
            </vSelect>
        </aside>

        <!-- list -->
        <div data-pagination-change-scroll-to>

            <p v-if="!displayedItems.length && !isLoading" class="text-center mb-4">
                {{ translate('No items available') }}
            </p>

            <article v-for="article in displayedItems" :key="article.id" class="mb-3">
                <div class="position-relative">
                    <a :href="article.link" class="stretched-link"></a>
                    <div>
                        <p class="text-secondary fw-semibold">
                            <small class="text-nowrap">
                                {{ article.date }}
                            </small>
                        </p>
                        <h2 class="text-truncate h6 my-2">
                            {{ article.heading }}
                        </h2>
                        <p class="text-truncate-lines-4">
                            {{ article.perex }}
                        </p>
                        <div class="hr-middle-after text-end mt-3">
                            <span class="bg-white text-secondary ps-5 pe-0 text-uppercase fw-semibold fs-3">{{ translate('More') }}</span>
                        </div>
                    </div>
                </div>
            </article>

        </div>

        <div class="mt-5 d-print-none">
            <Pagination 
                :items-count="filteredItems.length"
                v-model:current-page="pagination.currentPage" 
                v-model:per-page="pagination.perPage"
            />
        </div>

    </div>
</template>

<script>
import vSelect from 'vue-select';
import { paginate } from '@/scripts/helpers/pagination';
import { translate } from '@/scripts/mixins/translations';
import Pagination from '@/components/pagination/Pagination.vue';
import { watchFilters } from '@/scripts/mixins/filters';

export default {
    components: {
        Pagination,
        vSelect
    },
    mixins: [
        watchFilters(),
        translate
    ],
    data(){
        return {
            isLoading: false,
            filters: {
                type: new URL(window.location).searchParams.get('type') || 'active',
                order: new URL(window.location).searchParams.get('order') || 'alphabet'
            },
            pagination: {
                currentPage: 1,
                perPage: parseInt(localStorage.getItem('list-per-page')) || 10
            },
            projects: []
        }
    },
    methods: {
        selectType(type){

            if ( !type )
            {
                this.filters.type = 'active';
            }
            else
            {
                this.filters.type = type;
            }

        },
        loadProjects(){
            this.isLoading = true;

            axios.get(`projects/list`)
            .then(response => {
                const { data } = response;

                this.projects = data;
            })
            .finally(() => {
                this.isLoading = false;
            });
        }
    },
    computed: {
        filteredItems(){
            let list = this.projects;

            // filter by type
            if ( this.filters.type ) 
            {
                list = list.filter(article => {
                    return article.type === this.filters.type;
                });
            }

            // sort
            switch ( this.filters.order )
            {
                case 'date':
                    // by date
                    list = list.sort((a, b) => {
                        return new Date(b.dateIsoEnd) - new Date(a.dateIsoEnd)
                    });
                    break;
                default:
                    // alphabet
                    list = list.sort((a, b) => {
                        return a.heading.localeCompare(b.heading);
                    });
                    break;
            }

            return list;
        },
        displayedItems(){
            return paginate(this.filteredItems, this.pagination.currentPage, this.pagination.perPage);
        }
    },
    mounted(){
        this.loadProjects();
    }
}
</script>